<template>
  <tr>
    <td>
      {{ row.customer }}
    </td>
    <td>
      {{ row.businessUnitName }}
    </td>
    <td>
      {{ row.city }}, {{ row.state }}
    </td>
    <td>
      {{ row.category }}
    </td>
    <td>
      {{ row.jobStatus }}
    </td>
    <td>
      {{ row.remoteCompletedAt }}
    </td>
    <td>
      {{ row.tenant }}
    </td>

    <td v-if="row.mobileCheckin">
      <img :src="require(`mv/moment_state_icons/${checkinStateIcon}`)" width="16" height="16">

      <a :href="`/gb/moments/${row.mobileCheckin.id}/edit`">
        <span class="text-capitalize">{{ checkinStateTitle }}</span>
      </a>
    </td>
    <td v-else>-</td>

    <td>
      <a :href="`/gb/service_titan/jobs/${row.id}`">
        View
      </a>
    </td>
  </tr>
</template>

<script>
import { MOMENT_STATE_TO_IMAGE } from '../helpers'

export default {
  props: {
    row: { type: Object, required: true }
  },
  created() {
    if (this.row.mobileCheckin) {
      this.checkinStateTitle = this.row.mobileCheckin.state.split('_').join(' ')
      this.checkinStateIcon = MOMENT_STATE_TO_IMAGE[this.row.mobileCheckin.state]
    }
  }
}
</script>
